import { Link, useLocation } from "react-router-dom"
import dompurify from "dompurify";
import React, { useEffect, useRef } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import moment from "moment";
import { useState } from "react";


const PostList = React.forwardRef(({item, index, heightArr, type, type_2}, postGroupRef) => {
  
  // Use Hooks
  const location = useLocation()
  const sanitizer = dompurify.sanitize;

  const imgHost = process.env.REACT_APP_IMG_HOST;
  const newsHost = process.env.REACT_APP_NEWS_HOST;

  // JSON Parse Error Exception Handling
  const onFile = (data) => {
    try {
      const parseData = JSON.parse(data)
      return parseData[0];
    }
    catch (err) {
      return data
    }
  }
  const onTag = (data) => {
    try {
      //const parseData = JSON.parse(data.replace(/^"(.*)"$/, '$1'))    //앞 뒤 따옴표 없에는 코드. 나중에 관련 논의 필요
      const parseData = JSON.parse(data)
      if (parseData instanceof Array) {
        return parseData === null || parseData === undefined ? [] : parseData;
      }
      return []
    }
    catch (err) {
      return []
    }
  }

  // Column Grid 배치
  const postItemRef = useRef(null);
  const blockNum = 3

  useEffect(() => {
   posSet()
  }, [location, item])

  const posSet = () => {
    if(postItemRef.current !== null && (type === 'news' || type === 'conference')) {
      postItemRef.current.style = `display: block`;
      const itemWidth = postItemRef.current.clientWidth + 32 // width + gap size;
      const itemHeight = postItemRef.current.clientHeight + 32; // height + gap size
      
      heightArr.push({'value': itemHeight, 'index': index})
      
      // Max height size
      const colHeightArr = [0, 0, 0];
      for(let i = 0; i < blockNum; i++) {
        _.uniqBy(heightArr.filter(key => key.index % blockNum === i, "index")).map(key => colHeightArr[i] += key.value)
      }
      const maxHeight = Math.max(...colHeightArr)
      
      // Top Size 
      let topSize = 0;
      const curColItem = _.uniqBy(heightArr.filter(key => (key.index % blockNum === index % blockNum) && key.index !== index), "index")
      curColItem.map(key => topSize += key.value);
    
      // Set Posts Style
      postItemRef.current.style = `display: block; left: ${itemWidth * (index % blockNum)}px; top: ${topSize + 20}px;`
      postGroupRef.current.style = `height: ${maxHeight}px`
    }
  }


  return (
    <div className="postItem" ref={postItemRef} >
      {
      <>
        <Link to={`/connect/${type}/list/${item[`${type}_uuid`]}`}></Link>
        {
          (item[`${type}_file`]) && type_2 !== 'main' &&
          <p className="imgBox">
            <img src={`${type === 'news' ? newsHost : imgHost + '/'}${onFile(item[`${type}_file`])}`} alt="썸네일 이미지" />
          </p>
        }
        <div className="postInner">
          <div className="category">
            <p>{item[`${type}_cat`]}</p>

            {type === 'news' &&
              <div className="tagGroup">
                {onTag(item[`${type}_tag`]).map((tag, i) => 
                  <span key={i}>{tag.substring(0, 1) === '#' ? tag : '#' + tag}</span>
                )}
              </div>
            }
          </div>
          
          <div className="postTxtGroup">
            <h2>{item[`${type}_title`]}</h2>
            <div className="postCont">{item[`${type}_content`].replace(/<[^>]*>?/g, '')}</div>
          </div>

          <div className="registInfo">
            <p>{item[`${type}_author`] ? item[`${type}_author`] : item[`${type}_create_user`]}</p>
            <span>{moment(item[`${type}_fd`] ? item[`${type}_fd`] : item[`${type}_create_date`]).format('YYYY-MM-DD')}</span>
          </div>
        </div>
      </>
      }
    </div>
  )
});

export default PostList